const state = {
  shouldTypeStoryText: false,
  drawerOpen: false,
  mobileOpen: false,
  playExplosion: false,
  playSonar: false,
};

// getters
const getters = {
  shouldTypeStoryText: state => state.shouldTypeStoryText,
  drawerOpen: state => state.drawerOpen,
  mobileOpen: state => state.mobileOpen,
  playExplosion: state => state.playExplosion,
  playSonar: state => state.playSonar,
};

// actions
const actions = {
//   setBpm({ commit }, { bpm }) {
//     commit('setBpm', { bpm });
//     store.dispatch('palettes/updateBpm', { bpm });
//   }
};

// mutations
const mutations = {
  setShouldTypeStoryText(state, { shouldType }) {
    state.shouldTypeStoryText = shouldType;
  },
  setDrawerState(state, { open }) {
    state.drawerOpen = open;
  },
  setMobileState(state, { open }) {
    state.mobileOpen = open;
  },
  setExplosion(state, { play }) {
    state.playExplosion = play;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/ui.js